import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { formatCurrency } from "../../../Utils/helpers";

export default function RejectPayoutRequestModal({
  show,
  onHide,
  request,
  isProcessing,
  onConfirm,
}) {
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setReason("");
    onHide();
  };

  const handleConfirm = () => {
    onConfirm(reason.trim() || "Request rejected by admin.");
    setReason("");
  };

  if (!request) return null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop={isProcessing ? "static" : true}
      keyboard={!isProcessing}
      className="premium-cms-modal dp-payout-modal"
    >
      <Modal.Header className="cms-modal__header">
        <div className="cms-modal__header-main">
          <div className="cms-modal__header-icon cms-modal__header-icon--danger">
            <i className="fas fa-times" />
          </div>
          <div>
            <Modal.Title>Reject Payout Request</Modal.Title>
            <p className="cms-modal__subtitle">
              Driver will be notified that their request was declined.
            </p>
          </div>
        </div>
        <button type="button" className="btn-close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>

      <Modal.Body className="cms-modal__body">
        <div className="dp-reject-summary">
          <div>
            <strong>{request.name}</strong>
            <span>{formatCurrency(request.requestedAmount)}</span>
          </div>
          <span className="dp-reject-summary__date">
            Requested {moment(request.requestedAt).format("MMM D, YYYY")}
          </span>
        </div>

        <label className="dp-reject-label" htmlFor="reject-reason">
          Rejection Reason <span>*</span>
        </label>
        <textarea
          id="reject-reason"
          className="dp-reject-textarea"
          rows={3}
          placeholder="e.g. Minimum payout threshold not met, bank details incomplete…"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </Modal.Body>

      <Modal.Footer className="cms-modal-footer">
        <button type="button" className="cms-btn-cancel" onClick={handleClose} disabled={isProcessing}>
          Cancel
        </button>
        <button type="button" className="dp-btn-danger" onClick={handleConfirm} disabled={isProcessing}>
          {isProcessing ? "Rejecting…" : "Reject Request"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
